import * as React from "react";

const SvgTrap = ({ rackColor = "#001D3D" , ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="344"
    height="200"
    fill="none"
    viewBox="0 0 356 200"
  >
    <path
      d="M6 194h344v-53.714L242.698 6H100.68L6 140.286z"
      fill="none"
      stroke="black"
      strokeWidth="12"
    />
    <path
      fill="#D7EAFF"
      stroke={rackColor}
      strokeWidth="11"
      d="M6 194h344v-53.714L242.698 6H100.68L6 140.286z"
    ></path>
  </svg>
);

export default SvgTrap;
